import '../css/app.scss';
import './script/neto.js';
import { addEvent, appHeight } from './script/utils';
import lazyLoad from './script/lazyLoad';
import sliders from './script/slider';
import mobMenu from './script/mobMenu';
import readMore from './script/readmore';
import accordian from './script/accordian';
import headerPopups from './script/headerPopups';
import megamenu from './script/megamenuPos';
import stickyHeader from './script/stickyHeader';
import showHideFilters from './script/showHidefilters';
import showHideProducts from './script/showHideProducts';
import cartLine from "./script/cartLine";
import './script/popupCalls';
addEvent();
appHeight();

lazyLoad.init();
sliders.init();
mobMenu.init();
readMore.init();
accordian.init();
headerPopups.init();
megamenu.init();
stickyHeader.init();
showHideFilters.init();
showHideProducts.init();
cartLine.init();
